import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

// const PrivateRoute = ({ children }) => {
//     const authData = useSelector((state) => state.auth);

//     // Optional: fallback to localStorage in case of page refresh
//     const isAuthenticated = authData || JSON.parse(localStorage.getItem('profile'));

//     return isAuthenticated ? children : <Navigate to="/" replace />;
// };

const PrivateRoute = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(null); // null = checking, false = unauth, true = auth

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const res = await axios.get("https://api.inspiredformen.com/api/auth/check", {
                    withCredentials: true
                });
                setIsAuthenticated(true);
            } catch (err) {
                setIsAuthenticated(false);
            }
        };

        checkAuth();
    }, []);

    if (isAuthenticated === null) return <div>Loading...</div>; // or a spinner
    if (!isAuthenticated) return <Navigate to="/" replace />;
    return children;
};

export default PrivateRoute;